import axios from 'axios'

const baseURL = process.env.VUE_APP_PRODUCT_SERVICE + '/api/admin/providers'

export default {
  namespaced: true,
  state: {
    providers: [],
    is_loading: false,
    is_processing: false
  },
  mutations: {
    setProviders (state, payload) {
      state.providers = payload
    }
  },
  actions: {
    async getProviderList ({ commit }) {
      const response = await axios.get(baseURL)
      commit('setProviders', response.data)
    }
  }
}
